module.exports = __webpack_public_path__ + "static/media/shirts4.1e9d3f0b.jpg";